module.exports = "<!--<cat-menu-right></cat-menu-right>-->\r\n<!--<cat-menu-left></cat-menu-left>-->\r\n<!--<cat-top-bar></cat-top-bar>-->\r\n<!--<div class=\"cat__content\">-->\r\n    <!--<router-outlet></router-outlet>-->\r\n    <!--<cat-footer></cat-footer>-->\r\n<!--</div>-->"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/structure.html
// module id = ../../../../../src/app/structure/structure.html
// module chunks = main